<div class="table-header">
  <span>Network Servers</span>
  <!-- <div class="table-filter">
    <form class="form-inline join-servers-select short">
      <select id="" class="table-filter-search form-control">
        <option></option>
        <option></option>
        <option></option>
      </select>
    </form>
  </div> -->
  <div class="position-relative table-icon action">
    <i class="fa fa-list transition text-tooltip" aria-hidden="true" title-popup="List"></i>
    <div class="tooltip-actions width-120">
      <div class="arrow-up"></div>
      <ul>
        <li>
          <label col-id="0" table-name="network-servers-list" class="checked">NetID</label>
        </li>
        <li>
          <label col-id="1" table-name="network-servers-list" class="checked">NSID</label>
        </li>
        <li>
          <label col-id="2" table-name="network-servers-list" class="checked">Name</label>
        </li>
        <li>
          <label col-id="3" *ngIf="isAdmin" table-name="network-servers-list" class="checked">NS Group</label>
        </li>
        <li>
          <label col-id="4" *ngIf="isAdmin" table-name="network-servers-list" class="checked">Owner</label>
        </li>
        <li>
          <label col-id="5" *ngIf="isAdmin" table-name="network-servers-list" class="checked">Owner's Affiliation</label>
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="isAdmin" class="table-icon plus">
    <i [routerLink]="['/create-network-servers']" class="fa fa-plus transition text-tooltip" aria-hidden="true" title-popup="Add"></i>
  </div>
</div>
<div class="table-panel">
<table class="table table-striped" id="network-servers-list">
  <thead>
  <tr>
    <th>NetID</th>
    <th>NSID</th>
    <th>Name</th>
    <th>NS Group</th>
    <th *ngIf="isAdmin">Owner</th>
    <th *ngIf="isAdmin">Owner's Affiliation</th>
    <th *ngIf="isAdmin"></th>
  </tr>
  </thead>
  <tbody>

    <tr *ngFor="let item of list | paginate: configPagerGetAllNetworkServers">
      <td class="networkServers-netId-td"><a [routerLink]="['/network',item.virtId]">{{item.netIds | cidr}}</a></td>
      <td class="networkServers-netId-td">{{item.nsId}}</td>
      <td><a [routerLink]="['/network',item.virtId]">{{item.name}}</a></td>
      <td *ngIf="isAdmin" style="text-align: center;"><a *ngIf="isNsGroupMember(item)" [routerLink]="['/network-group',item.nsGroupId]"><i class="fa fa-check-circle fa-2x" aria-hidden="true"></i></a></td>
      <td *ngIf="!isAdmin" style="text-align: center;"><i *ngIf="isNsGroupMember(item)" class="fa fa-check-circle fa-2x" aria-hidden="true"></i></td>
      <td *ngIf="isAdmin">{{item.username}}</td>
      <td *ngIf="isAdmin">{{item.affiliation}}</td>
      <td *ngIf="isAdmin">
        <ng-template #actionsPopup>
          <p class="popup-text"
             (click)="userDetail.show();getUserDetails(item.username)"
             *ngIf="item.username">User details</p>
          <app-modal #userDetail
                     ownerUname="{{ownerUname}}"
                     ownerFname="{{ownerFname}}"
                     ownerLname="{{ownerLname}}"
                     ownerEmail="{{ownerEmail}}"
                     ownerAffiliation="{{ownerAffiliation}}"></app-modal>

          <!--Impersonate popover option-->
          <!--<p class="popup-text">Impersonate</p>-->

          <p class="popup-text" (click)="deleteModal.show()">Delete</p>
        </ng-template>

        <button class="view-detail-btn"
                [popover]="actionsPopup"
                placement="left"
                triggers="click"
                [outsideClick]="true"
                container="body">...</button>
          <app-delete-modal #deleteModal
                            text = "Network server {{item.name}}  will be deleted."
                            server="{{item.virtId}}"
                            deleteType="networkServer"></app-delete-modal>
      </td>
    </tr>

  </tbody>
</table>
</div>
<app-pagination-custom [config]="configPagerGetAllNetworkServers"></app-pagination-custom>
